import Layout from '@layout/Index'

export const imgFlowConfig = [
  {
    path: '/img-flow-config',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "img-flow-config-table" */ './pages/ImgFlowConfigTable.vue'),
        name: '图片流转配置列表',
        meta: {
          title: '图片流转配置列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "img-flow-config-form" */ './pages/ImgFlowConfigForm.vue'),
        name: '添加图片流转配置',
        meta: {
          title: '添加图片流转配置',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "img-flow-config-form" */ './pages/ImgFlowConfigForm.vue'),
        name: '修改图片流转配置',
        meta: {
          title: '修改图片流转配置',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "img-flow-config-detail" */ './pages/ImgFlowConfigDetail.vue'),
        name: '图片流转配置详情',
        meta: {
          title: '图片流转配置详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/img-flow-config/img-flow-config.route.js